import React from 'react';
import { disclaimerText } from '../../data/mock';

export const DisclaimerBar = () => {
  return (
    <div className="fixed top-20 left-0 right-0 z-40 bg-stone-50 border-b border-stone-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-2.5">
        <p className="text-xs text-stone-500 text-center leading-relaxed">
          {disclaimerText}
        </p>
      </div>
    </div>
  );
};
